import { render, staticRenderFns } from "./DialogPage.vue?vue&type=template&id=2f2a9668&scoped=true&"
import script from "./DialogPage.vue?vue&type=script&lang=js&"
export * from "./DialogPage.vue?vue&type=script&lang=js&"
import style0 from "./DialogPage.vue?vue&type=style&index=0&id=2f2a9668&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2a9668",
  null
  
)

export default component.exports